import { RootState } from "rootReducer";

export const selectIsAllDmpsLoading = (state: RootState) =>
  state.dmps.isAllLoading;

export const selectIsAllDmpsLoaded = (state: RootState) =>
  !!state.dmps.receivedAllAt;

export const selectAllDmpsById = (state: RootState) => state.dmps.byId;
